module.exports = __webpack_public_path__ + "static/media/book-search.70cc7cf1.PNG";